<template>
  <!-- Fixed overlay avoids iOS ion-modal touch/hit-test issues -->
  <div
    v-if="visible"
    class="retry-overlay"
    role="dialog"
    aria-modal="true"
  >
    <div class="retry-container">
      <div class="retry-box">
        <div class="retry-icon" v-if="showIcon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="48" height="48">
            <path fill="#ff6b6b" d="M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm75.31 260.69a16 16 0 11-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 01-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0122.62-22.62L256 233.37l52.69-52.68a16 16 0 0122.62 22.62L278.63 256z"/>
          </svg>
        </div>

        <h3 class="retry-title" v-if="title">{{ title }}</h3>
        <p class="retry-text">{{ message }}</p>

        <div class="button-group">
          <ion-button
            expand="block"
            :disabled="retrying"
            @click="handleRetry"
          >
            <ion-spinner v-if="retrying" name="crescent" slot="start"></ion-spinner>
            {{ retrying ? 'Retrying...' : 'Retry' }}
          </ion-button>

          <ion-button
            expand="block"
            fill="clear"
            color="medium"
            :disabled="retrying"
            @click="handleCancel"
          >
            Cancel
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RetryPopup",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: "Something went wrong. Please try again.",
    },
    title: {
      type: String,
      default: "Error",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      retrying: false,
    };
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.retrying = false;
      }
    },
  },
  methods: {
    async handleRetry() {
      if (this.retrying) {
        return;
      }
      this.retrying = true;
      this.$emit("retry");
      setTimeout(() => {
        this.retrying = false;
      }, 1000);
    },
    handleCancel() {
      if (this.retrying) {
        return;
      }
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.retry-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20000;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.retry-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  pointer-events: none;
}

.retry-box {
  background: #fff;
  width: 100%;
  max-width: 400px;
  padding: 32px 24px 24px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  pointer-events: auto;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.retry-icon {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
}

.retry-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #333;
}

.retry-text {
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 24px 0;
  color: #666;
}

.button-group ion-button {
  margin-top: 8px;
  font-weight: 500;
}

.button-group ion-button:first-child {
  --background: rgba(245, 52, 9, 0.8);
  --background-hover: #ff471c;
  --background-activated: #e63f19;
}

@media (max-width: 768px) {
  .retry-box {
    max-width: 340px;
    padding: 28px 20px 20px;
  }
}
</style>
